var $body;
var $window;
var $notifications;
var href_encoded = location.href;
var gmap_ready = false;
var htmlCanvas = null;
var gl = null;
var $grid;
var itemQueue = [];
var waypointsdelay = 100;
var queueTimer = null;
var KEYCODE_ESC = 27;

$(document).keyup(function (e) {
	"use strict";	
	if (e.keyCode === KEYCODE_ESC) {		
		/*CLOSE NAVIGATION*/
		if ($('#menu').hasClass('open')) {
			$('#menu').removeClass('open');
			$('body').removeClass('prevent-scroll');
		}
	}
});

$(window).load(function () {
	"use strict";
	
	$body = $('body');
	$window = $(window);
	
	setTimeout(function () {
		$('body').removeClass("loading");
		$('body').addClass('loaded');
		
		
	}, 200);	
});


$(window).on('resize orientationchange', function() {
	"use strict";	
	
	$('.project-showcase').slick('resize');
	
	if( $('.grid_publications').length || $('.grid_list').length ){
		$grid.isotope('layout');
	}
	
});

$(function () {
	"use strict";

	$body = $('body');
	$window = $(window);
		
	if( $body.hasClass('section-projects-details') ){
		$('#back-btn').addClass('back-btn-visible');
		$('#hamburger-btn').addClass('back-btn-visible');
	}
	$(document).on('click', '.share-open, .close-share-this', function () {
			
		if ($('body').hasClass('popup-open')) {

			$('body').removeClass('prevent-scroll');
			$('.share-this-section').removeClass('kva-popup');
			$('.kva-share-this').removeClass('kva-share-this-show');
			$('body').removeClass('popup-open');

		} else {

			$('.kva-share-this-form-container #share-title').html($('.data_holder').data('socialTitle'));
			$('.kva-share-this-form-container #share-caption').html($('.data_holder').data('socialCaption'));
			$('.kva-share-this-form-container #clipboard_text').attr('value', $('.data_holder').data('socialUrl'));
			var encodedURL = encodeURIComponent($('.data_holder').data('socialUrl')).replace(/!/g, '%21')
				.replace(/'/g, '%27')
				.replace(/\(/g, '%28')
				.replace(/\)/g, '%29')
				.replace(/\*/g, '%2A')
				.replace(/%20/g, '+');

			$('.kva-share-this-form-container #share-image').html('<img src="' + $('.data_holder').data('socialImg') + '" class="mx-auto d-block img-fluid" alt="' + $('.data_holder').data('socialTitle') + '" title="' + $('.data_holder').data('socialTitle') + '" />');


			$('.kva-share-this-form-container .fb_link').attr('href','https://www.facebook.com/dialog/feed?app_id=' + FACEBOOK_APP_ID + '&link=' + encodedURL );
			$('.kva-share-this-form-container .tw_link').attr('href', 'https://twitter.com/intent/tweet?text=' + encodedURL );
			$('.kva-share-this-form-container .li_link').attr('href', 'https://www.linkedin.com/shareArticle?mini=true&url=' + encodedURL );
			$('.kva-share-this-form-container .gp_link').attr('href', 'https://plus.google.com/share?url=' + encodedURL); 
			$('.kva-share-this-form-container .mail_link').attr('href', 'mailto:?subject=Katerina Valsamaki:: ' + $('.data_holder').data('socialTitle') + '&body=' + encodedURL);

			$('body').addClass('popup-open');
			$('.share-this-section').addClass('kva-popup');
			$('.kva-share-this').addClass('kva-share-this-show');
			$('body').addClass('prevent-scroll');

		}
		return false;
	});
	
	if( $('.grid_publications').length ){
		$grid = $('.grid_publications').isotope({
			itemSelector: '.publications ',
			layoutMode: 'masonry',
			getSortData: {
				category: '[data-category]',						
			 }
		});
		$grid.imagesLoaded().progress( function() {
		  $grid.isotope('layout');
		});
	}
	
	if( $('.grid_list').length ){
		
		$grid = $('.grid_list').isotope({
			itemSelector: '.griditem-full',
			layoutMode: 'masonry',
			getSortData: {
				category: '[data-category]',						
			 }
		});
		$grid.imagesLoaded().progress( function() {
		  $grid.isotope('layout');
		});
		
		$('.top-toolbar-content-left').on( 'click', 'a', function() {
			$( '.top-toolbar-content-left .active' ).removeClass('active');
			$( this ).addClass('active');
			var filterValue = $( this ).data('filter');					
			$grid.isotope({ filter: filterValue });					
		});	

		
		var $full_btn = $('#collection-models-counter__single-model-btn');
		var $grid_btn = $('#collection-models-counter__double-model-btn');
		
		$full_btn.addClass('active');
		$('.grid_list .griditem-full').each( function( index, element ){
			$(this).show();
		});
		$('.grid_list .griditem').each( function( index, element ){
			$(this).hide();
		});
		
		$grid_btn.click(function(e){
			
			if(!$grid_btn.hasClass('active')){ $grid_btn.addClass('active'); }
			if($full_btn.hasClass('active')){ $full_btn.removeClass('active'); }
			
			$grid.isotope('destroy');
			$('.grid_list .griditem-full').each( function( index, element ){
				$(this).hide();
			});
			$('.grid_list .griditem').each( function( index, element ){
				$(this).show();
			});		
			
			var $filter = $('.top-toolbar-content-left a.active').data('filter');
			$grid = $('.grid_list').isotope({
				itemSelector: '.griditem',
				layoutMode: 'masonry',
				filter : $filter,
				getSortData: {
					category: '[data-category]',						
				 }
			});
			e.preventDefault();			
			return false;			
		});
		
		$full_btn.click(function(e){
			if(!$full_btn.hasClass('active')){ $full_btn.addClass('active'); }
			if($grid_btn.hasClass('active')){ $grid_btn.removeClass('active'); }
			
			$grid.isotope('destroy');
			$('.grid_list .griditem').each( function( index, element ){
				$(this).hide();
			});
			$('.grid_list .griditem-full').each( function( index, element ){
				$(this).show();
			});
			
			var $filter = $('.top-toolbar-content-left a.active').data('filter');			
			$grid = $('.grid_list').isotope({
				itemSelector: '.griditem-full',
				layoutMode: 'vertical',
				filter : $filter,
				getSortData: {
					category: '[data-category]',						
				 }
			});
			
			
			e.preventDefault();
			return false;			
		});		
	}
	
	
	$(document).on('mouseover', '#menu-content__level-1 .card .card-header a', function(){
		$('#menu-content__level-1 .card .card-header a').each( function( index, element ){
			$(this).removeClass('activated');
		});
		$(this).addClass('activated');
		$('#menu-content__level-2').html('');
		$(this).closest('.card').find('.list-group').clone().appendTo('#menu-content__level-2');		
	});
	
	$('#menu-content__level-1 .card .card-header.with-subpages a').click(function(){
		var $this = $(this);
		if($(window).innerWidth()<992){
			$('#menu-content__level-1 .card .card-header.with-subpages a').removeClass('active').removeClass('activated');
			$this.addClass('active').addClass('activated');
			$('.visible-subcontent').removeClass('visible-subcontent');
			$this.parent().next().addClass('visible-subcontent');
			return false;
		}		
	});

	$(document).on('click', '#hamburger-btn', function (e) {
		$('body').addClass('prevent-scroll');
		$('#menu').addClass('open');
		e.preventDefault();
		return false;
	});
	
	$(document).on('click', '.close-menu-btn', function (e) {
		$('#menu').removeClass('open');
		$('body').removeClass('prevent-scroll');
		e.preventDefault();
		return false;
	});
	
	$(document).on('click', '#bottom-toolbar-bar-row', function (e) {
		if(!$('#bottom-toolbar-wrapper').hasClass('maximized')){
		    $('#bottom-toolbar-backdrop').show();
			$('#bottom-toolbar-wrapper').addClass('maximized');
			$('#bottom-toolbar-content').addClass('auto-height');
			$('body').addClass('prevent-scroll');
		}else{
			$('#bottom-toolbar-backdrop').hide();
			$('#bottom-toolbar-wrapper').removeClass('maximized');
			$('#bottom-toolbar-content').removeClass('auto-height');
			$('body').removeClass('prevent-scroll');
		}
		e.preventDefault();
		return false;
	});
	
	$(document).on('click', '.filters .filter', function (e) {
		var value = $(this).data('filterValue');
		var label = $(this).text();

		/*$('.filter-label').html(label).fadeIn(500);*/
		$('.filter-reset').fadeIn(500);

		filter(value);
		$('.popover').fadeOut(500);
		scroll2element('body', -5);
		e.preventDefault();
		return false;
	});
	
	$(document).on('click', '#bottom-toolbar-tab-btn', function (e) {
		
		if(!$(this).hasClass('active')){
			
			var target = $(this).attr("href");
			$('#bottom-toolbar-tab-btn.active').removeClass('active');
			$(this).addClass('active');
			
			$('.bottom-toolbar-tab.active').removeClass('active');
			$(target).addClass('active');
		}
		e.preventDefault();
		return false;
	});
});

function check_top_menu(){
	"use strict";
	if($(document).scrollTop()>50){
		$('.top-toolbar').addClass('top-toolbar-visible');
	}else{
		$('.top-toolbar').removeClass('top-toolbar-visible');
	}
}
function getScrollY() {
	"use strict";
	return window.pageYOffset || window.document.documentElement.scrollTop;
}
function scroll2element(el, offset) {
	"use strict";
	var position = $(el).offset();
	var o = offset || 0;
	$('html, body').stop().animate({
		scrollTop: position.top + o
	}, 1000);
}
